import React from 'react';
import { Modal, Popover, Select, Spin } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import s from './s.module.less';

const { Option } = Select;

type Props = Readonly<{
    open: boolean;
    onClose: () => void;
    selectedPeriod: number;
    onChangeSelectedPeriod: (val: number) => void;
    totalPayoutsReceived: number | undefined;
    totalPayoutsReceivedLoading: boolean;
    children: React.ReactNode;
}>;

export default function KlarityPayoutDetailsModal(props: Props) {
    const {
        open,
        onClose,
        selectedPeriod,
        onChangeSelectedPeriod,
        totalPayoutsReceived,
        totalPayoutsReceivedLoading,
        children,
    } = props;

    return (
        <Modal
            open={open}
            onCancel={onClose}
            closable
            footer={null}
            centered
            width={1160}
            destroyOnClose
            className={s.modal}
            closeIcon={<CloseOutlined className={s.closeIcon} />}
        >
            <div className={s.title}>Payments collected by Klarity</div>
            <div className={s.body}>
                <div className={s.overviewSectionItem}>
                    <div className={s.h}>
                        <div className={s.hLeft}>
                            <span>Total payments collected</span>
                            <Popover
                                trigger="hover"
                                content={
                                    <div className={s.pop}>
                                        Total payouts you’ve received from Klarity, including policy-related fees
                                        (no-show, late cancellation, rescheduling), co-pays, cash-pay charges, and text
                                        visit payouts.
                                    </div>
                                }
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                        stroke="#4B5563"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Popover>
                        </div>
                        <div className={s.hRight}>
                            <Select
                                value={selectedPeriod}
                                onChange={(value) => onChangeSelectedPeriod(value)}
                                className={s.select}
                                dropdownStyle={{ minWidth: '160px' }}
                            >
                                <Option value={1}>Last 1 month</Option>
                                <Option value={2}>Last 2 months</Option>
                                <Option value={3}>Last 3 months</Option>
                                <Option value={4}>Last 4 months</Option>
                                <Option value={5}>Last 5 months</Option>
                                <Option value={6}>Last 6 months</Option>
                            </Select>
                        </div>
                    </div>
                    <div className={s.priceWrap}>
                        <Spin spinning={totalPayoutsReceivedLoading} wrapperClassName={s.price}>
                            {totalPayoutsReceived == null ? 'N/A' : `$${totalPayoutsReceived}`}
                        </Spin>
                        <span className={s.priceDesc} />
                    </div>
                </div>

                <div className={s.tableSection}>{children}</div>
            </div>
        </Modal>
    );
}
